export default __webpack_public_path__ + "static/media/icon_azagros.b2c4f087.png";